import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../styles/Common.css';

const UserAgreement = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="container" style={{ padding: '40px 20px', maxWidth: '1000px', margin: '0 auto' }}>
      <button 
        onClick={() => navigate('/')} 
        style={{
          marginBottom: '20px',
          padding: '8px 16px',
          background: 'none',
          border: '1px solid #ddd',
          borderRadius: '20px',
          cursor: 'pointer',
          color: '#666',
          display: 'flex',
          alignItems: 'center',
          gap: '8px'
        }}
      >
        ← На главную
      </button>

      <div className="privacy-policy-content" style={{ background: '#fff', padding: '40px', borderRadius: '12px', boxShadow: '0 4px 6px rgba(0,0,0,0.05)' }}>
        <h1 style={{ marginBottom: '30px', fontSize: '2rem' }}>Публичная оферта</h1>

        <div className="privacy-policy-section">
          <h3>1. ОБЩИЕ ПОЛОЖЕНИЯ</h3>
          <p><strong>1.1.</strong> Настоящий документ является публичной офертой (предложением) самозанятого Макридина Евгения Романовича (далее — Исполнитель) неограниченному кругу лиц (далее — Заказчик) заключить договор на оказание услуг по предоставлению доступа к сервису генерации документов (далее — Сервис), размещенному в сети Интернет по адресу: https://www.dogovor-builder.ru (далее — Сайт).</p>
          <p><strong>1.2.</strong> В соответствии со ст. 437 Гражданского кодекса Российской Федерации (ГК РФ) данный документ является публичной офертой, и в случае принятия изложенных ниже условий и оплаты услуг Исполнителя, лицо, совершившее акцепт этой оферты, становится Заказчиком.</p>
          <p><strong>1.3.</strong> Акцептом (полным и безоговорочным принятием) условий настоящей оферты считается осуществление Заказчиком оплаты услуг на Сайте.</p>
        </div>

        <div className="privacy-policy-section">
          <h3>2. ПРЕДМЕТ ДОГОВОРА</h3>
          <p><strong>2.1.</strong> Исполнитель обязуется предоставить Заказчику доступ к функциональным возможностям Сервиса для автоматизированного формирования (генерации) документов на основании данных, введенных Заказчиком, а Заказчик обязуется оплатить эти услуги.</p>
          <p><strong>2.2.</strong> Результатом оказания услуги является предоставление Заказчику возможности скачивания сформированного документа в электронном виде (форматы PDF, DOCX или иные, доступные на Сайте).</p>
          <p><strong>2.3.</strong> Услуги оказываются "как есть". Исполнитель не оказывает юридических консультаций и не несет ответственности за соответствие сгенерированного документа конкретной жизненной ситуации Заказчика, если Заказчик ввел некорректные данные или выбрал условия, противоречащие его интересам.</p>
        </div>

        <div className="privacy-policy-section">
          <h3>3. СТОИМОСТЬ УСЛУГ И ПОРЯДОК РАСЧЕТОВ</h3>
          <p><strong>3.1.</strong> Стоимость услуг определяется в соответствии с тарифами, указанными на Сайте.</p>
          <p><strong>3.2.</strong> Оплата услуг производится в безналичном порядке с использованием платежных сервисов, доступных на Сайте.</p>
          <p><strong>3.3.</strong> Обязательство Заказчика по оплате считается исполненным с момента поступления денежных средств на счет Исполнителя.</p>
        </div>

        <div className="privacy-policy-section">
          <h3>4. ПРАВА И ОБЯЗАННОСТИ СТОРОН</h3>
          <p><strong>4.1. Исполнитель обязуется:</strong></p>
          <ul>
            <li>Обеспечить круглосуточную работоспособность Сайта, за исключением перерывов на техническое обслуживание.</li>
            <li>Обеспечить конфиденциальность данных, введенных Заказчиком, в соответствии с Политикой обработки персональных данных.</li>
            <li>Предоставить Заказчику сформированный документ для скачивания после оплаты.</li>
          </ul>
          
          <p><strong>4.2. Заказчик обязуется:</strong></p>
          <ul>
            <li>Вводить достоверные данные при использовании Сервиса.</li>
            <li>Самостоятельно проверять содержание сформированного документа перед его подписанием или использованием.</li>
            <li>Не использовать Сервис в противоправных целях.</li>
          </ul>
        </div>

        <div className="privacy-policy-section">
          <h3>5. ОТВЕТСТВЕННОСТЬ СТОРОН</h3>
          <p><strong>5.1.</strong> За неисполнение или ненадлежащее исполнение обязательств по настоящему Договору Стороны несут ответственность в соответствии с действующим законодательством Российской Федерации.</p>
          <p><strong>5.2.</strong> Исполнитель не несет ответственности за невозможность использования Сервиса по причинам, не зависящим от Исполнителя (отсутствие интернет-соединения у Заказчика, сбои в работе оборудования Заказчика и т.п.).</p>
          <p><strong>5.3.</strong> Исполнитель не несет ответственности за любые убытки Заказчика, возникшие в результате использования сформированных документов, так как Сервис является техническим инструментом, а не заменой профессиональной юридической помощи.</p>
        </div>

        <div className="privacy-policy-section">
          <h3>6. ВОЗВРАТ ДЕНЕЖНЫХ СРЕДСТВ</h3>
          <p><strong>6.1.</strong> Так как услуга потребляется в момент предоставления доступа к скачиванию файла, возврат денежных средств после предоставления такого доступа (генерации документа) не производится, за исключением случаев технических сбоев на стороне Сервиса, приведших к невозможности получения файла.</p>
          <p><strong>6.2.</strong> Претензии по качеству работы Сервиса принимаются на электронную почту admin@dogovor-builder.ru.</p>
        </div>

        <div className="privacy-policy-section">
          <h3>7. РЕКВИЗИТЫ ИСПОЛНИТЕЛЯ</h3>
          <p>Самозанятый Макридин Евгений Романович</p>
          <p>ИНН: 643922396500</p>
          <p>Email: admin@dogovor-builder.ru</p>
        </div>
      </div>
    </div>
  );
};

export default UserAgreement;
